<template>
    <div>
        <page-header :config="config" :active-stat="activeStat"></page-header>

        <statistic v-for="statistic in config.statistics"  v-bind:key="statistic.stat"
            :statistic="statistic"
            :active-stat="activeStat"
            v-if="activeStat.stat == statistic.stat"
        >
        </statistic>
    </div>
</template>
<script>
    import Header from './partials/header.vue';
    import Statistic from './partials/statisticComponentStatistic.vue';

    export default {
        props: ['config'],
        components: {
            'page-header': Header,
            'statistic': Statistic,
        },
        data(){
            let activeStat = this.config.statistics[0]
            for (let i in this.config.statistics) {
                if (this.config.statistics[i].isActive) {
                    activeStat = this.config.statistics[i];
                }
            }
            return {
                activeStat: activeStat,
            }
        },
        created() {
            Event.$on('statisticFilterChanged', (stat) => {
                for (let i in this.config.statistics) {
                    if(stat == this.config.statistics[i].stat) {
                        this.activeStat =  this.config.statistics[i];
                        break;
                    }
                }
            });
        }
    }
</script>



// WEBPACK FOOTER //
// resources/js/app/components/statistics-super-commissions/index.vue